/*
 * LGPD Popup
*/
	const siteLGPD = document.querySelector('[site-lgpd]')

	if (siteLGPD) {
		const siteLGPDCheck = localStorage.getItem('lgpd_terms_accepted')
		const siteLGPDDismiss = siteLGPD.querySelector('[site-lgpd-dismiss]')

		window.addEventListener('load', _ => {
			setTimeout(() => {
				if (!siteLGPDCheck) {
					siteLGPD.classList.add('is--visible')
					siteLGPDDismiss.focus()
				} else {
					siteLGPD.remove();
				}
			}, 3000)
		})

		siteLGPDDismiss.addEventListener('click', _ => {
			siteLGPD.classList.remove('is--visible')
			localStorage.setItem('lgpd_terms_accepted', true)

			setTimeout(function () {
				siteLGPD.remove()
			}, 1000)
		})
	}
